import { createAppAsyncThunk } from '../../../../common/thunk';
import { OnboardingRequest } from '../../onboardingRequest';
import OnboardingServices from '../../../../services/onboarding.services';
import { MediaState } from './mediaSlice';

interface IPicture {
  id: string;
  url: string;
}

interface IAdditionalPicture extends IPicture {
  group: string;
  description?: string;
}

export interface MediaPatchRequestData {
  profilePicture?: IPicture;
  pictures?: IAdditionalPicture[];
  instagram?: string;
  video?: string[];
}

export const prepareMedia = (media: MediaState): MediaPatchRequestData => {
  const { profile, additional, instagram, videos } = media;
  return {
    profilePicture: profile?.uuid ? { id: profile?.uuid || '', url: profile?.cdnUrl || '' } : undefined,
    pictures: additional.map(it => ({
      group: it.groupId,
      id: it.image.uuid,
      url: it.image.cdnUrl,
      description: it.description,
    })),
    instagram,
    video: videos.map(it => it.value),
  };
};

export const confirmMediaStep = createAppAsyncThunk('onboarding/confirmMediaStep', (requestData: OnboardingRequest) => {
  const id = requestData.id;
  if (!requestData.media) {
    throw Error('Missed Media data');
  }
  return OnboardingServices.confirmOnboardingMedia(id, requestData.media).then(response => response.data);
});
